import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label,
  FormGroup
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import RelatorioApi from '../../relatorio.api';
import CommonFunctions from '@common/util/functions.common';
import SelectComponent from '@componentes/select/select.component';
import InputMaskPhone from '@componentes/InputMaskPhone';
import IntlMessage from "../../../../helpers/intlMessage";

function ModalAdicionarRequisicao({ showModal, onModal }) {
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.usuario);
  const medicos = useSelector(state => state.commonReducer.medicos);
  const laudoSelecionado = useSelector(
    state => state.relatorio.laudoSelecionado
  );

  const [modalAberto, setModalAberto] = useState(false);
  const [registro, setRegistro] = useState({});

  useEffect(() => {
    setModalAberto(showModal);
    dispatch(commonActions.showModal(showModal));

    const data = CommonFunctions.formatDateHour(new Date().toISOString());
    const { laudo } = laudoSelecionado;
    setRegistro({ data, laudo, usuario: usuario.usuario });
  }, [showModal, laudoSelecionado]);

  const toggle = () => {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    onModal(!modalAberto);
  };

  const salvar = () => {
    dispatch(commonActions.showFadeCarregando(true));
    RelatorioApi.post(registro).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));
      toggle();
      const mensagem = <IntlMessage id = "dashboards.reports.notificationSuccess"/>
      dispatch(commonActions.showAlerta('sucesso', mensagem, 3000));
    });
  };

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-lg modal-registro-contato-critico'
          centered
          backdrop={false}
          keyboard={true}
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={toggle}>
            <IntlMessage id = "dashboards.reports.criticalReportContact"/>
          </ModalHeader>

          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.user"/></Label>
                  <Input value={registro.usuario} readOnly={true} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.examDetail.date"/></Label>
                  <Input value={registro.data} readOnly={true} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.reports.notifiedRequestingPhysician"/></Label>
                  <Input
                    value={registro.medico || ''}
                    onChange={(e) => {
                      let medico = !e.target.value ? '' : e.target.value.replace(/[^a-záàâãéèêíïóôõöúçñA-ZÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ ]+/g, '');
                      setRegistro({ ...registro, medico: medico })
                    }}
                    styles={{ borderColor: 'transparent' }}
                    maxLength={60}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <InputMaskPhone
                    name='telefone'
                    label={<IntlMessage id = "dashboards.reports.phone"/>}
                    value={registro.telefone}
                    onChange={value =>
                      setRegistro({ ...registro, telefone: value })
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id = "dashboards.reports.comment"/></Label>
                  <Input
                    type='textarea'
                    rows={3}
                    value={registro.notificacao}
                    onChange={e =>
                      setRegistro({ ...registro, notificacao: e.target.value })
                    }
                    maxLength={999}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={toggle}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id = "general.requestsPanel.close"/>
            </Button>
            <Button
              color='primary'
              onClick={() => salvar()}
              disabled={
                !registro.notificacao || !registro.telefone || !registro.medico
              }
            >
              <IntlMessage id = "general.requestsPanel.save"/>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default ModalAdicionarRequisicao;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/RegistroDeContato/index.js